import * as Types from '../graphql.generated';

export type GetTrackedPropertyQueryVariables = Types.Exact<{
    uprn: Types.Scalars['String'];
}>;

export type GetTrackedPropertyQuery = { __typename?: 'Query' } & {
    property?: Types.Maybe<
        { __typename?: 'Property' } & {
            address?: Types.Maybe<
                { __typename?: 'Address' } & Pick<
                    Types.Address,
                    'outcode' | 'postcode'
                >
            >;
            liveListings?: Types.Maybe<
                Array<
                    { __typename?: 'LiveListing' } & Pick<
                        Types.LiveListing,
                        'listingId'
                    >
                >
            >;
            attributes?: Types.Maybe<
                { __typename?: 'Attributes' } & Pick<
                    Types.Attributes,
                    'bedrooms' | 'bathrooms'
                >
            >;
            saleEstimate?: Types.Maybe<
                { __typename?: 'SaleEstimate' } & Pick<
                    Types.SaleEstimate,
                    | 'lowerPrice'
                    | 'currentPrice'
                    | 'upperPrice'
                    | 'confidenceLevel'
                >
            >;
            rentEstimate?: Types.Maybe<
                { __typename?: 'RentEstimate' } & Pick<
                    Types.RentEstimate,
                    'currentPrice'
                >
            >;
            trackedProperty?: Types.Maybe<
                { __typename?: 'TrackedProperty' } & Pick<
                    Types.TrackedProperty,
                    'isTracked'
                >
            >;
        }
    >;
};

export const GetTrackedPropertyDocument = `
    query getTrackedProperty($uprn: String!) {
  property(uprn: $uprn) {
    address {
      outcode
      postcode
    }
    liveListings {
      listingId
    }
    attributes {
      bedrooms
      bathrooms
    }
    saleEstimate {
      lowerPrice
      currentPrice
      upperPrice
      confidenceLevel
    }
    rentEstimate {
      currentPrice
    }
    trackedProperty {
      isTracked
    }
  }
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {
        getTrackedProperty(
            variables: GetTrackedPropertyQueryVariables,
            options?: C
        ): Promise<GetTrackedPropertyQuery> {
            return requester<
                GetTrackedPropertyQuery,
                GetTrackedPropertyQueryVariables
            >(GetTrackedPropertyDocument, variables, options);
        },
    };
}
export type Sdk = ReturnType<typeof getSdk>;
